import { styled, Select } from '@mui/material';

export const StyledSelect = styled(Select)(() => ({
  justifySelf: 'stretch',
}));
